{
  "Clear search": "Rensa sökningen"
}
